import Header from "../../commons/header";
import Footer from "../../commons/footer";
import AboutContent from "./about-content";

function About() {
  return (
    <div>
      <Header />
      <AboutContent />
      <Footer />
    </div>
  );
}

export default About;
